import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const NAMES_ES = [{
  name: 'María G.',
  location: 'Ciudad de México, MX'
}, {
  name: 'Ana S.',
  location: 'Buenos Aires, AR'
}, {
  name: 'Carmen R.',
  location: 'Madrid, ES'
}, {
  name: 'Laura M.',
  location: 'Bogotá, CO'
}, {
  name: 'Patricia L.',
  location: 'Lima, PE'
}, {
  name: 'Isabel V.',
  location: 'Santiago, CL'
}, {
  name: 'Rosa T.',
  location: 'Caracas, VE'
}, {
  name: 'Sofía P.',
  location: 'Quito, EC'
}, {
  name: 'Gabriela H.',
  location: 'Montevideo, UY'
}, {
  name: 'Daniela C.',
  location: 'San José, CR'
}];
const NAMES_EN = [{
  name: 'Sarah M.',
  location: 'New York, NY'
}, {
  name: 'Jennifer L.',
  location: 'Los Angeles, CA'
}, {
  name: 'Emily R.',
  location: 'Chicago, IL'
}, {
  name: 'Jessica T.',
  location: 'Houston, TX'
}, {
  name: 'Ashley K.',
  location: 'Phoenix, AZ'
}, {
  name: 'Amanda S.',
  location: 'Philadelphia, PA'
}, {
  name: 'Melissa W.',
  location: 'San Antonio, TX'
}, {
  name: 'Michelle B.',
  location: 'San Diego, CA'
}, {
  name: 'Stephanie D.',
  location: 'Dallas, TX'
}, {
  name: 'Rebecca H.',
  location: 'Austin, TX'
}];
export function PurchaseNotification() {
  const {
    t,
    language
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [currentPerson, setCurrentPerson] = useState(NAMES_ES[0]);
  useEffect(() => {
    const names = language === 'es' ? NAMES_ES : NAMES_EN;
    const showNotification = () => {
      const randomPerson = names[Math.floor(Math.random() * names.length)];
      setCurrentPerson(randomPerson);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // First notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);
    // Subsequent notifications every 12-18 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 6000 + 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [language]);
  return <AnimatePresence data-id="element-47">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4" data-id="element-48">
          <div className="bg-gradient-to-br from-[#2C4A3E] to-[#1F3329] rounded-xl shadow-2xl border border-[#D4A574]/30 overflow-hidden max-w-md w-full" data-id="element-49">
            <div className="flex items-center gap-4 p-4" data-id="element-50">
              {/* Book Cover Image */}
              <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden shadow-lg" data-id="element-51">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3eue4QpepZ2rvNVUGT8Lok/ChatGPT_Image_23_nov_2025%2C_20_10_54.png" alt="Book cover" className="w-full h-full object-cover" data-id="element-52" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-53">
                <div className="flex items-center gap-2 mb-1" data-id="element-54">
                  <div className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse shadow-[0_0_8px_rgba(16,185,129,0.6)]" data-id="element-55" />
                  <p className="text-[#D4A574] text-sm font-medium" data-id="element-56">
                    {t.notification.recentPurchase}
                  </p>
                </div>
                <p className="text-white font-semibold text-base mb-1" data-id="element-57">
                  {currentPerson.name}{' '}
                  <span className="text-white/70 font-normal" data-id="element-58">
                    {t.notification.from} {currentPerson.location}
                  </span>
                </p>
                <p className="text-[#D4A574] text-sm" data-id="element-59">
                  {t.notification.ebook} •{' '}
                  <span className="font-semibold" data-id="element-60">$9.97</span>
                </p>
              </div>

              {/* Close Button */}
              <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-white/50 hover:text-white transition-colors p-1" aria-label="Close notification" data-id="element-61">
                <X className="w-5 h-5" data-id="element-62" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}